import * as z from "zod";

export interface Props {
  modalIsOpen: boolean;
  unitTitle?: string;
  unitId: string;
  housingId: string;
}

const ActualUnitSchema = z.object({
  ordinal: z.int(),
  id: z.uuidv4(),
  status: z.string().optional(),
  name: z.string().min(1, "Name should have at least 1 character").max(255, "Name shouldn't be over 255 characters"),
  update: z.boolean(),
  errors: z.string().array(),
});

export type ActualUnit = z.infer<typeof ActualUnitSchema>;

export const ActualUnitsListSchema = z.array(ActualUnitSchema);

export interface LocalState {
  editableActualUnits: Array<ActualUnit>;
}

export interface Emits {
  closeModal: [];
}
